import React, { useState, useEffect } from "react";

//components
import SignTypes from "./SignTypes";
import Modal from "../../components/Modal/Modal";
import L from "leaflet";
import { polylineMeasure } from "leaflet.polylinemeasure"; //do not Remove
import easyButton from "leaflet-easybutton"; //do not Remove
import "leaflet-draw/dist/leaflet.draw";
import "leaflet-draw/dist/images/layers-2x.png";
import "leaflet-draw/dist/images/layers.png";
import "leaflet-draw/dist/images/marker-icon-2x.png";
import "leaflet-draw/dist/images/marker-icon.png";
import "leaflet-draw/dist/images/marker-shadow.png";
import "leaflet-draw/dist/images/spritesheet-2x.png";
import "leaflet-draw/dist/images/spritesheet.png";
import "leaflet-draw/dist/images/spritesheet.svg";
import "leaflet-draw/dist/leaflet.draw-src.css";
import "leaflet-draw/dist/leaflet.draw-src";
import "leaflet.fullscreen";
import "leaflet.coordinates/dist/Leaflet.Coordinates-0.1.5.min";
import "leaflet.coordinates/dist/Leaflet.Coordinates-0.1.5.css";
import "font-awesome/css/font-awesome.min.css";
import "leaflet.locatecontrol/dist/L.Control.Locate.min.css";
import "leaflet.locatecontrol/dist/L.Control.Locate.min.js";

//styles
import useStyle from "./styles";

function Sign() {
  const classes = useStyle();
  const [mapCenter, setMapCenter] = useState([24.17, 60.06]);
  const [showModal, setShowModal] = useState(false);
  const [layer, setLayer] = useState(null);
  useEffect(() => {
    window.signMap = L.map("signMap", {
      zoomControl: false,
      // fullscreenControl: true,
    }).setView(mapCenter, 7);
    L.control.zoom({ position: "bottomright" }).addTo(window.signMap);
    L.tileLayer("http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(
      window.signMap,
    );

    var mbUrl =
      "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw";

    var dark = L.tileLayer(mbUrl, {
        id: "mapbox/dark-v10",
        tileSize: 512,
        zoomOffset: -1,
      }),
      streets = L.tileLayer(mbUrl, {
        id: "mapbox/streets-v11",
        tileSize: 512,
        zoomOffset: -1,
      }),
      satellite = L.tileLayer(mbUrl, {
        id: "mapbox/satellite-v9",
        tileSize: 512,
        zoomOffset: -1,
      }),
      light = L.tileLayer(mbUrl, {
        id: "mapbox/light-v10",
        tileSize: 512,
        zoomOffset: -1,
      });

    var baseLayers = {
      Streets: streets,
      Dark: dark,
      Light: light,
      satellite: satellite,
    };

    L.control.layers(baseLayers).addTo(window.signMap);

    let options = {
      position: "topright",
      clearMeasurementsOnStop: true,
      showBearings: false,
      showClearControl: true,
      showUnitControl: true,
      distanceShowSameUnit: true,
    };

    L.control.polylineMeasure(options).addTo(window.signMap);

    L.control
      .coordinates({
        position: "bottomleft",
        decimals: 6,
        decimalSeperator: ",",
        labelTemplateLat: "Latitude: {y}",
        labelTemplateLng: "Longitude: {x}",
      })
      .addTo(window.signMap);
    var lc = L.control
      .locate({
        position: "topright",
        strings: {
          title: "Show Your Location",
        },
      })
      .addTo(window.signMap);
    // L.easyButton("fa-gbp", function () {
    //   window.signMap.setView([55, -2], 4);
    // }).addTo(window.signMap);

    // L.easyButton("fa-jpy", function () {
    //   window.signMap.setView([38, 139], 4);
    // }).addTo(window.signMap);

    // L.easyButton("fa-usd", function () {
    //   window.signMap.setView([37.8, -96], 3);
    // }).addTo(window.signMap);

    let drawnItems = L.featureGroup().addTo(window.signMap);
    var MyCustomMarker = L.Icon.extend({
      options: {
        shadowUrl: null,
        iconAnchor: new L.Point(12, 12),
        iconSize: new L.Point(24, 24),
        iconUrl:
          "https://upload.wikimedia.org/wikipedia/commons/6/6b/Information_icon4_orange.svg",
      },
    });
    window.signMap.addControl(
      new L.Control.Draw({
        edit: {
          featureGroup: drawnItems,
          poly: {
            allowIntersection: false,
          },
        },
        draw: {
          polygon: {
            allowIntersection: false,
            showArea: true,
          },
          marker: {
            icon: new MyCustomMarker(),
          },
        },
      }),
    );

    window.signMap.on(L.Draw.Event.CREATED, function (event) {
      var type = event.layerType,
        layer = event.layer;
      // layer.bindPopup("sign");

      drawnItems.addLayer(layer);
      // layer.openPopup();
      setShowModal(true);
      setLayer(layer);
    });

    return () => {};
  }, []);
  return (
    <div className={classes.mainContainer}>
      <div id="signMap" className={classes.signMap}></div>
      {showModal ? (
        <Modal title="Sign Information" setShowModal={setShowModal}>
          <SignTypes layer={layer} setShowModal={setShowModal} />
        </Modal>
      ) : null}
    </div>
  );
}

export default Sign;
